var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentRupee3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#FFF4ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5167_37202)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.8417,
    height: 32.8417,
    transform: "translate(11.5781 11.7246)",
    fill: "#FFF4ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4854 20.9544H21.899C23.4991 19.7078 25.4851 19.0049 27.5515 19.0049C32.016 19.0049 35.7987 22.1484 36.5459 26.4795L38.5508 26.1437C37.6367 20.8453 33.0109 17 27.5515 17C24.9406 17 22.4346 17.9179 20.4466 19.5387V17.9971H18.4131V22.9596H23.4857V20.9544H23.4854ZM31.6264 34.9746H33.2926C31.6778 36.2647 29.6548 36.9951 27.5512 36.9951C23.0836 36.9951 19.301 33.8491 18.5557 29.5142L16.5508 29.8489C17.4618 35.1517 22.0881 39 27.5512 39C30.1643 39 32.6759 38.0797 34.6655 36.4547V37.9324H36.6991V32.9696H31.6264V34.9746Z",
    fill: "var(--primary-color-text)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2899 33L24.5508 28.3782V27.7619H24.8696C25.3817 27.7619 25.8117 27.7152 26.1595 27.6218C26.517 27.5285 26.7972 27.3744 27.0001 27.1597C27.203 26.9449 27.3237 26.6508 27.3624 26.2773H24.5508V25.381H27.3479C27.2802 25.0355 27.145 24.7554 26.9421 24.5406C26.7392 24.3165 26.4638 24.1531 26.116 24.0504C25.7778 23.9477 25.3624 23.8964 24.8696 23.8964H24.5508V23H30.5508V23.8964H27.8117C28.0339 24.0738 28.2174 24.2838 28.3624 24.5266C28.5073 24.7694 28.5991 25.0542 28.6377 25.381H30.5508V26.2773H28.6667C28.5991 26.9589 28.3286 27.4911 27.8551 27.874C27.3914 28.2474 26.773 28.4855 26.0001 28.5882L28.7682 33H27.2899Z",
    fill: "var(--primary-color-text)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5167_37202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.8417,
    height: 32.8417,
    fill: "white",
    transform: "translate(11.5781 11.7246)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentRupee3);
export default __webpack_public_path__ + "static/media/Payment_Rupee3.198c5721c31539f4d7434ef9bbc8046e.svg";
export { ForwardRef as ReactComponent };